/* eslint-disable import/no-unresolved */
import { isLoyaltyProgramEnabled } from '@vuejs/utils/loyaltyProgram';
import { readAuthCache } from '@vuejs/utils/authCache';

const SELECTORS = {
    item: '.product-item',
    loyaltyBanner: '.js-product-loyalty-banner',
    percentSlot: '.js-loyalty-discount-percent',
    levelWrap: '.js-loyalty-level-wrap',
    levelSlot: '.js-loyalty-level-name',
};

const readLoyaltyData = () => {
    try {
        // Wpis z innej sesji moze nalezec do wylogowanego klienta.
        const cached = readAuthCache();
        const user = cached?.sameSession ? cached.user : null;
        const benefit = (user?.loyalty?.benefits || []).find(
            (b) => b.benefit_type === 'discount_percent' && b.is_active !== false
        );
        const discount = benefit ? Number(benefit.value) || 0 : 0;
        const levelName = user?.loyalty?.account?.current_level?.name || '';
        return { discount, levelName };
    } catch {
        return { discount: 0, levelName: '' };
    }
};

const apply = () => {
    if (!isLoyaltyProgramEnabled()) return;

    const { discount, levelName } = readLoyaltyData();

    document.querySelectorAll(SELECTORS.item).forEach((item) => {
        const banner = item.querySelector(SELECTORS.loyaltyBanner);
        if (!banner) return;

        if (discount > 0) {
            const percentSlot = banner.querySelector(SELECTORS.percentSlot);
            if (percentSlot) percentSlot.textContent = String(discount);

            const levelWrap = banner.querySelector(SELECTORS.levelWrap);
            const levelSlot = banner.querySelector(SELECTORS.levelSlot);
            if (levelSlot) levelSlot.textContent = levelName;
            if (levelWrap) levelWrap.classList.toggle('d-none', !levelName);

            banner.classList.remove('d-none');
        } else {
            banner.classList.add('d-none');
        }
    });
};

['DOMContentLoaded', 'RemoteContentLoaded', 'products-list-loaded'].forEach((ev) => {
    window.addEventListener(ev, apply);
});

window.addEventListener('datalayer.auth_login', apply);
window.addEventListener('datalayer.auth_logout', apply);

export default apply;
